<template>
    <div>
        <crime_statistics></crime_statistics>
    </div>
  </template>
  
  <script>
  import crime_statistics from '@/components/Statistics/crime_statistics.vue'
  
  export default {
    name: 'KaimonoTop',
    components: {
      crime_statistics,
    },
    setup() {

      return {
      }
    }
  }
  </script>
  